


















helpers = require('../../helpers.coffee')

view_model =
  components:
    newTag: require('./new')
    list: require('./list')

  data: ->
    list_item_options:
      checkbox: false
      can_edit: true

  methods:
    tagCreated: (tag) ->
      @$refs.list.tags.unshift(tag)

  beforeCreate: ->
    if Session.current_user.isSeller() || Session.current_user.isMonitoringManager()
      @$router.push('/configuracoes/perfil')

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/tags/index.vue